import {
    exportExel,exportExel_blob
  } from '@/api'
  import { getApiHost } from '@/utils/config';
  const downloadExcel = function (vue, taskId) {
    if (taskId) {
      exportExelFn(taskId)
    } else {
      vue.downloading = false;
      throw new Error('taskId 不存在');
    }
  
    async function exportExelFn(taskId) {
      const exportStatusRes = await exportExel(taskId);
  
      if (exportStatusRes.status === 0) {
        switch (exportStatusRes.data.status) {
          case 0:
            setTimeout(() => {
              exportExelFn(taskId)
            }, 1500)
            break
          case 2:
            vue.$message.info('导出失败')
            vue.downloading = false
            break;
          case 3:
            vue.$message.info('取消导出')
            vue.downloading = false
            break;
        }
      } else {
        const ret = await exportExel_blob(taskId);
        const blob = new Blob([ret], {'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        let href = ''; 
        if(window.URL) href = window.URL.createObjectURL(blob); 
        else href = window.webkitURL.createObjectURL(blob); 
        let a = document.createElement('a');
        a.href = href;
        a.download = '';
        a.click();
        if(window.URL) window.URL.revokeObjectURL(href); 
        vue.$message.success('导出成功');
        vue.downloading = false;

        vue.$nextTick(() => {
          taskId = null;
          vue = null;
          a = null;
        })
      }
    }
  }
  
  export default downloadExcel;
  